import BaseComponent from 'components/pages/FuelComsumption/Vehicles';
import {
  getVehicles,
  deleteVehicles,
} from 'domains/api/fuel_comsumption/vehicles';
import { resetCurrentUser } from 'domains/current_user';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Vehicle } from 'types';

const Vehicles: React.FC = () => {
  const navigate = useNavigate();

  const [vehicles, setVehicles] = useState<Vehicle[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    void getVehicles()
      .then((response) => {
        setVehicles(response.vehicles);
        setIsLoading(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  }, [navigate]);

  const onClickEdit = (vehicle: Vehicle) =>
    navigate(`/fuel_consumption/vehicles/${vehicle.id}/refuel_histories`);
  const onClickDelete = (vehicle: Vehicle) => {
    setIsLoading(true);
    void deleteVehicles(vehicle)
      .then((_) => {
        const updatedVehicles = [...vehicles];
        const index = vehicles.findIndex((v) => v.id === vehicle.id);
        updatedVehicles.splice(index, 1);
        setVehicles(updatedVehicles);
        setIsLoading(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  };

  return (
    <BaseComponent
      isLoading={isLoading}
      vehicles={vehicles}
      onClickNew={() => navigate('/fuel_consumption/vehicles/new')}
      onClickEdit={onClickEdit}
      onClickDelete={onClickDelete}
    />
  );
};

export default Vehicles;
